export const LOAD_STARTED = '@@react-pages/load-started'
export const LOAD_FINISHED = '@@react-pages/load-finished'
export const LOAD_FAILED = '@@react-pages/load-failed'